<template>
  <v-dialog :model-value="dialogPreviewPdf" max-width="900" width="90%">
    <v-card>
      <v-card-title>
        <v-row no-gutters align="center">
          {{ title || 'Preview PDF' }}
          <v-spacer></v-spacer>
          <v-btn
            icon="mdi-close"
            size="small"
            variant="text"
            @click="$emit('closeDialogPreviewPdf')"
          ></v-btn>
        </v-row>
      </v-card-title>
      <v-divider></v-divider>
      <template v-if="loading">
        <v-row justify="center" class="pa-10">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-row>
      </template>
      <template v-else>
        <iframe
          v-if="pdfBlobUrl"
          width="100%"
          height="600"
          :src="pdfBlobUrl"
          frameborder="0"
        ></iframe>
        <v-alert
          v-else
          type="info"
          class="ma-4"
          text="File PDF tidak dapat ditampilkan"
        ></v-alert>
      </template>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text="Tutup"
          class="px-6 text-none border"
          @click="$emit('closeDialogPreviewPdf')"
        ></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    dialogPreviewPdf: { type: Boolean, required: true },
    guid: { type: String, default: '' },
    title: { type: String, default: 'Preview PDF' },
    source: { type: String, default: 'tugas' }, // 'tugas', 'journal', dll
  },
  data() {
    return {
      loading: false,
      pdfBlobUrl: '',
    };
  },
  computed: {
    apiUrl() {
      const urlMap = {
        tugas: `/master-schedule/tugas/${this.guid}/view`,
        'kelompok-tugas': `/master-schedule/kelompok-kerja/${this.guid}/view-file`,
        // Tambahkan source lain di sini jika diperlukan
        // journal: `/journal/${this.guid}/view`,
      };
      return urlMap[this.source] || urlMap.tugas;
    },
  },
  watch: {
    dialogPreviewPdf(isOpen) {
      if (isOpen && this.guid) {
        this.fetchPdf();
      } else if (!isOpen) {
        // Revoke blob URL saat dialog ditutup untuk menghindari memory leak
        if (this.pdfBlobUrl) {
          URL.revokeObjectURL(this.pdfBlobUrl);
          this.pdfBlobUrl = '';
        }
      }
    },
  },
  methods: {
    async fetchPdf() {
      this.loading = true;
      try {
        // const blob = await fetchBelajarWajibBlob(this.apiUrl, 'GET');
        const event = useRequestEvent();
        const res = await fetchBelajarWajib(event, this.apiUrl, 'GET');
        if (res){
          const blob = new Blob([res], { type: 'application/pdf' });
          this.pdfBlobUrl = URL.createObjectURL(blob);
        }
      } catch (error) {
        useUserStore().$patch({
          snackStatus: 'error',
          snackbar: true,
          messageSnack: error?.message || 'Gagal memuat file PDF.',
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
